import { Core } from "@faire/design-tokens";
import { isNullish } from "@faire/typescript";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

export const RowWithDivider: React.FunctionComponent<{
  children: React.ReactNode[];
  dividerVariant?:
    | "paragraphSansMedium"
    | "displayXLSerifRegular"
    | "displayLSerifRegular"
    | "displayMSerifRegular"
    | "displaySSerifRegular"
    | "displaySSansSemiBold"
    | "displaySSansRegular";
  dividerColor?: string;
  divider?: string;
}> = ({ children, dividerVariant, dividerColor, divider }) => {
  if (isNullish(children)) {
    return null;
  }

  const childrenFiltered = children.filter(
    (el: React.ReactNode) => !isNullish(el)
  );
  const rowContent = childrenFiltered.map((el: React.ReactNode, i) => (
    <React.Fragment key={`${i}`}>
      {el}
      {i !== childrenFiltered.length - 1 ? (
        <>
          <Spacer width={4} />
          <Typography
            variant={dividerVariant ? dividerVariant : "paragraphSansMedium"}
            color={dividerColor ? dividerColor : Core.text.subdued}
            data-test-id="row-divider"
          >
            {divider ? divider : " · "}
          </Typography>
          <Spacer width={4} />
        </>
      ) : null}
    </React.Fragment>
  ));

  return (
    <Row align="center" className="flex-wrap gap-y-[4px]">
      {rowContent}
    </Row>
  );
};

export const StringWithDivider: React.FunctionComponent<{
  children: (string | null | undefined)[];
  divider: string;
}> = ({ children, divider }): string => {
  if (isNullish(children)) {
    return "";
  }
  const childrenFiltered = children.filter(
    (el: string | null | undefined) => !isNullish(el)
  );
  const numChildren = childrenFiltered.length;
  return childrenFiltered.reduce(
    (acc: string, el: string | null | undefined, i) => {
      if (i === numChildren - 1) {
        return acc + (el || "");
      }
      return acc + el + divider;
    },
    ""
  );
};
